import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/components/ui/use-toast';

export const useCsvFileAnalyses = () => {
  const [isDeleting, setIsDeleting] = useState(false);

  const { data: analyses, isLoading, refetch } = useQuery({
    queryKey: ['csvAnalyses'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('sys_util_csv_analysis')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  const handleDelete = async (id: string, filePath: string) => {
    if (isDeleting) return;
    setIsDeleting(true);

    try {
      // Delete the file from storage
      const { error: storageError } = await supabase.storage
        .from('csv_uploads')
        .remove([filePath]);

      if (storageError) throw storageError;

      // Delete the analysis record
      const { error: dbError } = await supabase
        .from('sys_util_csv_analysis')
        .delete()
        .eq('id', id);

      if (dbError) throw dbError;

      toast({
        title: "Success",
        description: "Analysis deleted successfully",
      });

      refetch();
    } catch (error: any) {
      console.error('Delete error:', error);
      toast({
        title: "Delete failed",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    analyses,
    isLoading,
    refetch,
    handleDelete,
  };
};
